const DEVICE_STORAGE_KEY = 'nosi-device-id'

const generateDeviceId = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }

  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID()
  }

  return Math.random().toString(36).substring(2)
}

export const ensureDeviceId = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }

  let deviceId = localStorage.getItem(DEVICE_STORAGE_KEY)
  if (!deviceId) {
    deviceId = generateDeviceId()
    localStorage.setItem(DEVICE_STORAGE_KEY, deviceId)
  }

  return deviceId
}
